export default __webpack_public_path__ + "img/error-blob.d28bfa9.svg";